import {Injectable} from '@angular/core';
@Injectable()
export class PlanService {

    selectedPlan;
    subsciptionID;
    oldSubscriptionID;

    setPlan(plan){
        this.selectedPlan = plan;
    }

    getPlan(){
        return this.selectedPlan;
    }

    setSubscription(subsciptionID){
      this.subsciptionID = subsciptionID;
    }

    getSubscription(){
      return this.subsciptionID;
    }

    setOldSubscription(subsciptionID){
      this.oldSubscriptionID = subsciptionID;
    }

    getOldSubscription(){
      return this.oldSubscriptionID;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/planService.ts